import { Line } from 'vue-chartjs';

export default {
	extends: Line,
	data() {
		return {
			value: '',
			avg: '',
		};
	},
	mounted() {
		axios({
			method: 'POST',
			url: '/api/analytics/result',
		}).then(response => {
			this.value = response.data.tendency_value;
			this.avg = response.data.tendency_avg;

			this.renderChart(
				{
					labels: [['목표 및 행동관리'], ['문제해결'], ['대인관계'], ['가치관 및 태도']],
					datasets: [
						{
							label: '값',
							backgroundColor: 'rgb(255, 255, 255)',
							borderWidth: 2,
							borderColor: 'rgb(42, 125, 225)',
							data: [this.value[1], this.value[2], this.value[3], this.value[4]],
							fill: false,
						},
						{
							label: '내 역량의 평균',
							backgroundColor: 'rgb(255, 255, 255)',
							borderWidth: 2,
							borderColor: 'rgb(207, 212, 215)',
							data: [this.avg, this.avg, this.avg, this.avg],
							fill: false,
							borderDash: [10, 5],
						},
					],
				},
				{
					responsive: false,
					elements: {
						line: {
							tension: 0,
						},
					},
					layout: {},
					title: {
						display: true,
						text: '역량 군',
						padding: 16,
					},
					tooltips: {
						enabled: false,
						mode: 'index',
						intersect: false,
					},
					hover: {
						mode: 'nearest',
						intersect: true,
					},
					scales: {
						xAxes: [
							{
								display: true,
								gridLines: {
									display: false,
								},
								ticks: {
									padding: 4,
								},
							},
						],
						yAxes: [
							{
								display: false,
								ticks: {
									padding: 10,
								},
							},
						],
					},
					legend: {
						position: 'bottom',
						labels: {
							fontSize: 10,
							padding: 20,
						},
					},
				},
			);
		});
	},
};
